import { createContext, useContext } from 'react';

/** App-wide chat UI services: translation, language, page viewer. */
export const ChatUiContext = createContext({
  t: (s) => s,
  langOpt: 'English',
  openViewer: () => {},
});

/** Per-message data the markdown citation chips need. */
export const MessageContext = createContext({
  message: null,
  sourceById: {},
  hoveredSourceId: null,
  setHoveredSourceId: () => {},
  openSource: () => {},
});

export const useChatUi = () => useContext(ChatUiContext);
export const useMessageContext = () => useContext(MessageContext);
